export default "__VITE_ASSET__CGNN_w4S__"